var map = {
	"./Facebook.png": "9a63",
	"./Instagram.png": "e1e3",
	"./Linkedin.png": "b88b",
	"./Logo_Lila_mc.png": "020b",
	"./Twitter.png": "3a04",
	"./Youtube.png": "5836",
	"./age_icon.png": "8c2f",
	"./android_badge.png": "711e",
	"./bottom_bg.png": "602d",
	"./cards_icon.png": "39f1",
	"./gameplay.png": "3d00",
	"./home_cards.png": "951d",
	"./ios_badge.png": "3977",
	"./logo.png": "cf05",
	"./medicine.png": "a377",
	"./overlay_bg.png": "dd5c",
	"./patro_1.png": "7ccf",
	"./patro_2.png": "5fbc",
	"./patro_3.png": "032c",
	"./patro_4.png": "89fb",
	"./patro_5.png": "ed16",
	"./patro_6.png": "5d3f",
	"./players_icon.png": "4b7b",
	"./prim_background.png": "fdc1",
	"./timer_icon.png": "a27d",
	"./video.png": "01f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";